<template>
    <div v-if="$store.getters.GET_ACTIVE_ADDRESS">
        <div class="row d-flex flex-row justify-content-center address-bar mb-2">
            <div class="address-box">
                <div class="left-col skiptranslate">
                    <i class="icon icon-pin" aria-hidden="true"></i>
                    <span class="address-box__title">
                        {{ this.$store.getters.GET_ACTIVE_ADDRESS.displayName }}
                    </span>
                </div>
                <div v-if="isReducedView == false && $store.getters.GET_PERSONAL_INFO.type === 'resident' && !$store.getters.GET_FAVORITES.list.find(l => l.id === this.$store.getters.GET_ACTIVE_ADDRESS.id)" class="right-col cursor-pointer"  @click="pin" tabindex="0" @keydown="pinKeyEvent">
                    <i class="icon icon-pushpinempty" aria-hidden="true" v-bind:style="{color : MainUISettings.button_color}"></i>
                    <span class="btn-pin" v-bind:style="'color:' + MainUISettings.button_color">{{ TEXTS.render(`ADDRESS_PIN_BTN_PIN`) }}</span>   
                </div>
                <div v-else-if="isReducedView == false && $store.getters.GET_PERSONAL_INFO.type === 'resident' && $store.getters.GET_FAVORITES.list.find(l => l.id === this.$store.getters.GET_ACTIVE_ADDRESS.id)" class="right-col">
                    <i class="icon icon-pushpinfill" aria-hidden="true"></i>
                    <span class="btn-pin" :style="'color: gray'">{{ TEXTS.render(`ADDRESS_PIN_BTN_PINNED`) }}</span>  
                </div>
            </div>
        </div>
        <div v-if="isReducedView == false" class="row d-flex flex-row justify-content-center address-bar mb-3">
            <button type="button" class="btn btn--white text-center btn-booknow" :style="'background-color:' + MainUISettings.button_color + '; color:' + MainUISettings.button_text_color" @click='viewBookingHistory'>{{ $store.getters.GET_SITE_WORDINGS.bookhistory_button_label || printBookingHistoryBtnText }}</button>
            <button type="button" class="btn btn--blue text-center btn-booknow" :style="'background-color:' + MainUISettings.button_color + '; color:' + MainUISettings.button_text_color" @click='bookNow'>{{ siteWording || TEXTS.render(`ADDRESS_PIN_BTN_BOOK_NOW`) }}</button>
        </div>
    </div>
</template>

<script>
    import BookingStateManager from '../../../../common/utils/BookingStateManager';
    import Texts from '../../../../common/utils/Texts';
    import GeneralBookingSettingMixin from '../../../../common/mixins/GeneralBookingSettingMixin';
    import BookingAddressMixin from '../../../../common/mixins/BookingAddressMixin';

    export default {
        mixins: [GeneralBookingSettingMixin, BookingAddressMixin],
        props: {
            isReducedView: {
                type: Boolean,
                default: false
            },
        },
        mounted() {
            // this.$store.dispatch('mainUI');
        },
        methods: {
            pin(event) {
                event.preventDefault();
                if (!this.$store.getters.GET_FAVORITES.saving) {
                    this.$store.dispatch('postFavorite', [this.$store.getters.GET_ACTIVE_ADDRESS, 'add-favorite'])
                        .then(() =>{
                            Toastify({
                                text: Texts.render(`ADDRESS_PIN_BTN_PIN_SUCCESS`),
                                duration: 3000,
                                gravity: "bottom",
                                position: 'right', 
                                style: {
                                    background: '#00B029'
                                },
                                offset: {
                                    x: '2rem',
                                    y: '2rem'
                                },
                                onClick: function(){} // Callback after click
                            }).showToast();
                        });
                }
            },
            pinKeyEvent(event){
                if (event.keyCode == 32 || event.keyCode == 13) {
                    event.preventDefault();
                    this.pin(event)
                }
            },
            bookNow(){
                // Get the active address
                var activeAddress = this.$store.getters['GET_ACTIVE_ADDRESS']
                if(!activeAddress){
                    return;
                }

                if (this.searchAddressToList(activeAddress.displayName)) {
                    window.eventBus.$emit(
                        "alertDoubleBooking",
                        this.TEXTS.render(`BOOKING_FORM_MULTIPLE_BOOKING_ERROR_MESSAGE`)
                    );
                    return false;
                }

                this.addToAddressList(activeAddress.displayName);
                //Resets Step Form Index
                this.$store.dispatch('resetStepFormIndex');
                var bookingManager = new BookingStateManager();
                var transaction = bookingManager.newBooking(activeAddress);
                
                // Verify if complete
                if(transaction && transaction.id && transaction.activeAddress){
                    var userType = this.$store.getters.GET_PERSONAL_INFO.type;
                    switch(userType){
                        case 'cso': // CSO Users have the booking opened on a new tab (US-68)
                            var routeOptions = { 
                                path: transaction.url.form
                            };
                            let routeData = this.$router.resolve(routeOptions);
                            window.open(routeData.href, '_blank'); 
                            break;
                        default:
                            this.$router.push(transaction.url.form);
                            break;
                    }
                }
                
            },
            viewBookingHistory(){
                // Get the active address
                var activeAddress = this.$store.getters['GET_ACTIVE_ADDRESS']
                if(!activeAddress){
                    return;
                }

                //Resets Step Form Index
                var id = activeAddress.id
                this.$store.dispatch('setActiveAddress', activeAddress);
                var bookingManager = new BookingStateManager();
                bookingManager.upsertAddressMap(activeAddress)
            

                var userType = this.$store.getters.GET_PERSONAL_INFO.type;
                var routeOptions = { path: 'history', query: { id: id }}
                switch(userType){
                    case 'cso':
                        let routeData = this.$router.resolve(routeOptions);
                        window.open(routeData.href, '_blank'); 
                        break;
                    default: 
                        this.$router.push(routeOptions);
                        break;
                }
            }
        },
        computed: {
            TEXTS: () => Texts,
            MainUISettings() {
                return this.$store.getters['GET_MAIN_UI']; 
            }
        }
    }
</script>